<template>
  <form method="POST" class="input_new notice-form" @submit="submit($event)">
    <div v-for="rubric of rubrics">
      <checkbox-input
        name="RUBRIC[]"
        :value="rubric.CHECKED"
        :label="rubric.NAME"
        @input="check(rubric.ID, $event)"
      ></checkbox-input>
      <div class="sb-desc_subscribe">
        <span class="sb-descript_notice" v-html="htmlDecode(rubric.DESCRIPTION)"> </span>
      </div>
    </div>
    <br>
    <btn type="submit"></btn>
  </form>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { htmlDecode } from '../../utils/string'
  import CheckboxInput from '../form/CheckBoxInput'
  import Btn from '../form/Btn'

  export default {
    name: 'subscribe',
    components: {Btn, CheckboxInput},
    created () {
      if (this.rubrics.length <= 0) {
        this.$store.dispatch('subscribe/fetchRubrics')
      }
    },
    computed: {
      ...mapGetters('subscribe', [
        'rubrics'
      ])
    },
    methods: {
      submit ($event) {
        $event.preventDefault()
        this.$store.dispatch('subscribe/save')
      },
      check (id, value) {
        this.$store.commit('subscribe/setChecked', {id, value})
      },
      htmlDecode (text) {
        return htmlDecode(text)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Personal/Subscribe.vue